import React, {useEffect, useState} from 'react';
import {
  Alert,
  App,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
} from 'antd';
import './add.css';
import {useNavigate} from 'react-router-dom';
import {InfoCircleOutlined} from '@ant-design/icons';
import {
  commonSelectAll,
  getLocalChapterSelectLabel,
  validatePhoneNumber,
  maxTagPlaceholder,
  tagRender,
  maxTagPlaceholderKeyword,
  NoEmptySpaceInput,
  OnlyAlphabetInputValidator,
  validateEmailInput,
  validateCompanyName,
  OnlyAlphabetInputValidatorWithSpecialCharacters,
  useCountryState,
  getTopmostErrorField,
  scrollAndFocusFormErrorField,
} from '../../../Util/commonUtility';
import CommonPageHeroText from './../../CommonComponents/CommonPageHeroText/index';
import useLocalization from '../../../Localization';

const UserUpdateProfileComponent = (props) => {
  const {ApplicationString} = useLocalization();
  const [form] = Form.useForm();
  let Navigate = useNavigate();
  const {userData, localChaptersList, mailPreferenceChaptersList, otherChapterId, updateUser, keywordsOptions} =
    props;
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [checkboxState, setCheckboxState] = useState([]);
  const watchedMailPreference = Form.useWatch('mail_preference', form);
  const isMailPreferenceEmpty =
    !watchedMailPreference ||
    !Array.isArray(watchedMailPreference) ||
    watchedMailPreference.length === 0;
  const {
    stateOptions,
    selectedCountry,
    selectedStates,
    countriesData,
    handleStateChange,
    handleCountryChange,
    setSelectedCountry,
  } = useCountryState(userData, form);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    if (userData) {
      form.setFieldsValue({
        ...userData,
        is_vendor_reps: userData?.is_vendor_reps
          ? userData?.is_vendor_reps
          : false,
        confirm_email: userData?.email,
        local_chapter_id: {
          ...userData?.local_chapter_id,
          label: getLocalChapterSelectLabel(
            userData?.local_chapter_id,
            otherChapterId,
          ),
          value: userData?.local_chapter_id?.id,
        },
        mail_preference: userData?.mail_preference?.map((item, index) => {
          return {
            ...item,
            label: item?.name,
            value: item?.id,
          };
        }),
        user_keywords: userData?.keywords?.map((item, index) => {
          return {
            ...item,
            label: item?.name,
            value: item?.id,
          };
        }),
      });
      setSelectedCountry(userData?.country);
      setSelectedKeywords(
        userData?.keywords?.map((item) => {
          return item?.id;
        }),
      );
    }
  }, [userData, otherChapterId]);

  const onReset = () => {
    Navigate('/');
  };

  const handleKeywordChange = (value) => {
    setSelectedKeywords(value);
  };

  const onFinish = (values) => {
    const MailPrefArray = values.mail_preference?.map((chapter) => {
      return chapter?.value || chapter;
    });
    const Data = {
      ...values,
      phone_number: values?.phone_number ? values?.phone_number : null,
      state: values?.state ? values?.state : '',
      mail_preference: MailPrefArray,
      user_keywords: selectedKeywords || [],
      local_chapter_id:
        values?.local_chapter_id?.value || values?.local_chapter_id,
      isTermsAccepted: true,
    };
    updateUser(Data, userData?.id, Navigate);
  };

  const onFinishFailed = (errorInfo) => {
    scrollAndFocusFormErrorField(
      getTopmostErrorField(errorInfo, 'basic'),
      form,
    );
  };

  const handleSelectMailChange = (value) => {
    const selectAllData = mailPreferenceChaptersList
      ?.filter((item) => item?.value !== 'all')
      ?.map((item) => item?.value);
    if (value.includes('all')) {
      setCheckboxState([...selectAllData, 'all']);
      form.setFieldsValue({
        mail_preference: selectAllData,
      });
    } else {
      setCheckboxState(value);
    }
  };

  const handleMailPrefCheckboxChange = (value, checked) => {
    const selectedValues = mailPreferenceChaptersList
      ?.filter((item) => item?.value !== 'all')
      ?.map((item) => item?.value);
    if (checked) {
      if (value == 'all') {
        setCheckboxState([...selectedValues, 'all']);
      } else {
        setCheckboxState([...checkboxState, value]);
      }
    } else {
      if (value == 'all') {
        setCheckboxState([]);
        form.setFieldsValue({
          mail_preference: [],
        });
      } else {
        setCheckboxState(checkboxState.filter((item) => item !== value));
      }
    }
  };

  return (
    <React.Fragment>
      <CommonPageHeroText
        heading={ApplicationString['userUpdateProfileComponent.update_profile']}
        subheading={ApplicationString['userUpdateProfileComponent.subheading']}
      />
      <div className='main-form-container-update-profile'>
        <Form
          form={form}
          name='basic'
          layout='vertical'
          onFinish={onFinish}
          className='two-column-form-update-profile'
          onFinishFailed={onFinishFailed}
          initialValues={''}
          autoComplete='off'>
          <div className='input-container'>
            <div className='form-column'>
              <Form.Item
                label={
                  ApplicationString[
                    'userUpdateProfileComponent.first_name.label'
                  ]
                }
                name='first_name'
                rules={[
                  {
                    required: true,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.first_name.validationMessage'
                      ],
                  },
                  {
                    validator: (_, value) =>
                      OnlyAlphabetInputValidatorWithSpecialCharacters(
                        value,
                        'First name',
                      ),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.first_name.placeholder'
                    ]
                  }
                />
              </Form.Item>

              <Form.Item
                label={
                  ApplicationString['userUpdateProfileComponent.title.label']
                }
                initialValue={null}
                name='title'
                rules={[
                  {
                    validator: (_, value) => NoEmptySpaceInput(value, 'Title'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.title.placeholder'
                    ]
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString['userUpdateProfileComponent.address.label']
                }
                name='address'
                rules={[
                  {
                    required: false,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.address.validationMessage'
                      ],
                  },
                  {
                    validator: (_, value) =>
                      NoEmptySpaceInput(value, 'Address Line 1'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.address.placeholder'
                    ]
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString['userUpdateProfileComponent.country.label']
                }
                name='country'
                rules={[
                  {
                    required: true,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.country.validationMessage'
                      ],
                  },
                ]}>
                <Select
                  prefixCls='common-select-register'
                  showSearch
                  className='space'
                  allowClear
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? '').includes(
                      input?.toLowerCase(),
                    )
                  }
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.country.placeholder'
                    ]
                  }
                  options={countriesData}></Select>
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString['userUpdateProfileComponent.city.label']
                }
                name='city'
                initialValue={''}
                rules={[
                  {
                    validator: (_, value) =>
                      OnlyAlphabetInputValidator(value, 'City'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.city.placeholder'
                    ]
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString['userUpdateProfileComponent.notes.label']
                }
                name='notes'
                rules={[
                  {
                    validator: (_, value) => NoEmptySpaceInput(value, 'Notes'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.notes.placeholder'
                    ]
                  }
                />
              </Form.Item>
            </div>
            <div className='form-column'>
              <Form.Item
                label={
                  ApplicationString[
                    'userUpdateProfileComponent.last_name.label'
                  ]
                }
                name='last_name'
                rules={[
                  {
                    required: true,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.last_name.validationMessage'
                      ],
                  },
                  {
                    validator: (_, value) =>
                      OnlyAlphabetInputValidatorWithSpecialCharacters(
                        value,
                        'Last name',
                      ),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.last_name.placeholder'
                    ]
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString['userUpdateProfileComponent.company.label']
                }
                name='company'
                rules={[
                  {
                    required: true,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.company.validationMessage'
                      ],
                  },
                  {
                    validator: (_, value) =>
                      validateCompanyName(value, 'Company name'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.company.placeholder'
                    ]
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString['userUpdateProfileComponent.address2.label']
                }
                name='address2'
                rules={[
                  {
                    required: false,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.address2.validationMessage'
                      ],
                  },
                  {
                    validator: (_, value) =>
                      NoEmptySpaceInput(value, 'Address Line 2'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.address2.placeholder'
                    ]
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString['userUpdateProfileComponent.state.label']
                }
                name='state'>
                <Select
                  prefixCls='common-select-register'
                  showSearch
                  className='space'
                  allowClear
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? '').includes(
                      input?.toLowerCase(),
                    )
                  }
                  value={stateOptions}
                  onChange={handleStateChange}
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.state.placeholder'
                    ]
                  }
                  options={selectedStates}></Select>
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString[
                    'userUpdateProfileComponent.postal_code.label'
                  ]
                }
                name='postal_code'
                initialValue={''}
                rules={[
                  {
                    validator: (_, value) =>
                      NoEmptySpaceInput(value, 'Postal code'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.postal_code.placeholder'
                    ]
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  ApplicationString[
                    'userUpdateProfileComponent.phone_number.label'
                  ]
                }
                name='phone_number'
                rules={[
                  {
                    validator: (_, value) =>
                      validatePhoneNumber(value, 'Phone number'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.phone_number.placeholder'
                    ]
                  }
                />
              </Form.Item>
            </div>
          </div>
          <div className='input-container'>
            <div className='form-column'>
              <Form.Item
                name='local_chapter_id'
                label={
                  ApplicationString[
                    'userUpdateProfileComponent.local_chapter_id.label'
                  ]
                }
                rules={[
                  {
                    required: true,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.local_chapter_id.validationMessage'
                      ],
                  },
                ]}>
                <Select
                  prefixCls='common-select-register'
                  showSearch
                  className='space'
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    option?.label.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                  }
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.local_chapter_id.placeholder'
                    ]
                  }
                  options={localChaptersList}></Select>
              </Form.Item>
              <Form.Item
                label={
                  <div className='detailLabelAndTextMessageContainer'>
                    <span className='detailsLabel'>
                      {
                        ApplicationString[
                          'userUpdateProfileComponent.email.label'
                        ]
                      }
                    </span>
                    <span className='detailsTextMessage'>
                      <InfoCircleOutlined />{' '}
                      {
                        ApplicationString[
                          'userUpdateProfileComponent.email.textMessage'
                        ]
                      }{' '}
                      <a href='mailto:info@pbss.org'>
                        {' '}
                        {
                          ApplicationString[
                            'sponsorAddComponent.contactUs.link'
                          ]
                        }
                      </a>
                    </span>
                  </div>
                }
                name='email'
                initialValue={null}
                rules={[
                  {
                    required: true,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.email.validationMessage'
                      ],
                  },
                  {
                    validator: (_, value) => validateEmailInput(value, 'Email'),
                  },
                ]}>
                <Input
                  prefixCls='update-profile-common-input'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.email.placeholder'
                    ]
                  }
                  disabled={true}
                />
              </Form.Item>
            </div>
          </div>
          <div className='input-container'>
            <div className='form-column'>
              {isMailPreferenceEmpty && (
                <Alert
                  type='info'
                  showIcon
                  icon={<InfoCircleOutlined />}
                  message={
                    ApplicationString[
                      'userUpdateProfileComponent.mail_preference.emptyStateInfo'
                    ]
                  }
                  style={{marginBottom: 16}}
                />
              )}
              <Form.Item
                name='mail_preference'
                label={
                  ApplicationString[
                    'userUpdateProfileComponent.mail_preference.label'
                  ]
                }>
                <Select
                  id='basic-selection-chapters'
                  prefixCls='common-select-register'
                  mode='multiple'
                  showSearch
                  allowClear
                  maxTagCount={'responsive'}
                  maxTagPlaceholder={maxTagPlaceholder}
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    String(option?.searchLabel ?? option?.label ?? '')
                      .toLowerCase()
                      .includes(String(input ?? '').toLowerCase())
                  }
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.mail_preference.placeholder'
                    ]
                  }
                  onChange={handleSelectMailChange}
                  tagRender={tagRender}
                  defaultValue={
                    mailPreferenceChaptersList?.filter(
                      (data) => data?.value !== 'all',
                    )?.value
                  }
                  options={
                    (mailPreferenceChaptersList &&
                      commonSelectAll(mailPreferenceChaptersList)?.map((item) => ({
                        label: (
                          <Checkbox
                            checked={checkboxState.includes(item.value)}
                            onChange={(e) =>
                              handleMailPrefCheckboxChange(
                                item.value,
                                e.target.checked,
                              )
                            }>
                            {item.label}
                          </Checkbox>
                        ),
                        value: item.value,
                        searchLabel: item.label ?? '',
                      }))) ||
                    []
                  }></Select>
              </Form.Item>
            </div>
          </div>
          <div className='input-container'>
            <div className='form-column'>
              <Form.Item
                label={
                  ApplicationString[
                    'userUpdateProfileComponent.area_of_interest.label'
                  ]
                }
                name='user_keywords'>
                <Select
                  prefixCls='common-select-register'
                  mode='multiple'
                  showSearch
                  maxTagCount={'responsive'}
                  maxTagPlaceholder={maxTagPlaceholderKeyword}
                  allowClear
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    String(option?.label ?? '')
                      .toLowerCase()
                      .includes(String(input ?? '').toLowerCase())
                  }
                  onChange={handleKeywordChange}
                  tagRender={tagRender}
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.area_of_interest.placeholder'
                    ]
                  }
                  options={keywordsOptions}></Select>
              </Form.Item>
            </div>
          </div>
          <div className='input-container'>
            <div className='form-column'>
              <Form.Item
                label={
                  ApplicationString[
                    'userUpdateProfileComponent.area_of_interest.label2'
                  ]
                }
                name='area_of_interest'
                rules={[
                  {
                    required: false,
                    message:
                      ApplicationString[
                        'userUpdateProfileComponent.area_of_interest.validationMessage'
                      ],
                  },
                  {
                    validator: (_, value) => {
                      const regex = /\s{4,}/g;
                      // added extra validation cause it was causing second error message from antd
                      if (value && value?.length <= 0) {
                        return Promise.reject(new Error(''));
                      }
                      if (value && value.trim() === '') {
                        return Promise.reject(
                          new Error('Area of interest cannot include space!'),
                        );
                      } else if (value && regex.test(value)) {
                        return Promise.reject(
                          new Error('Too many consecutive spaces!'),
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  },
                ]}>
                <Input
                  prefixCls='common-input-user'
                  className='genral-form'
                  placeholder={
                    ApplicationString[
                      'userUpdateProfileComponent.country.area_of_interest.label'
                    ]
                  }
                />
              </Form.Item>
            </div>
          </div>
          <Row gutter={10} className='register-buttons'>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item>
                <Button
                  prefixCls='register-submit'
                  id='register-register-button'
                  type='primary'
                  className='register-button'
                  htmlType='submit'>
                  {
                    ApplicationString[
                      'userUpdateProfileComponent.update_profile'
                    ]
                  }
                </Button>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item>
                <Button
                  onClick={onReset}
                  prefixCls='register-cancel'
                  id='register-cancel-button'
                  className='register-button'>
                  {ApplicationString['userUpdateProfileComponent.cancel']}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default UserUpdateProfileComponent;
